var map = {
	"./baby-leggings.jpg": 332444,
	"./baby-leggings@2x.jpg": 53988,
	"./backpacks.jpg": 442116,
	"./backpacks@2x.jpg": 593452,
	"./basic-tote.jpg": 490996,
	"./basic-tote@2x.jpg": 772092,
	"./beanies-youth.jpg": 730812,
	"./beanies-youth@2x.jpg": 729476,
	"./bedroom.jpg": 532717,
	"./bedroom@2x.jpg": 196023,
	"./blanket.jpg": 752888,
	"./blanket@2x.jpg": 875464,
	"./bottles-and-tumblers.jpg": 815701,
	"./bottles-and-tumblers@2x.jpg": 240543,
	"./boxer-briefs.jpg": 919105,
	"./boxer-briefs@2x.jpg": 19395,
	"./boyshorts.jpg": 733614,
	"./boyshorts@2x.jpg": 805246,
	"./cheeky-briefs.jpg": 985762,
	"./cheeky-briefs@2x.jpg": 618586,
	"./cotton-fabrics.jpg": 499381,
	"./cotton-fabrics@2x.jpg": 91967,
	"./cotton-market-tote.jpg": 712364,
	"./cotton-market-tote@2x.jpg": 898324,
	"./cotton-silk-bandana.jpg": 667342,
	"./cotton-silk-bandana@2x.jpg": 237150,
	"./day-tote.jpg": 534540,
	"./day-tote@2x.jpg": 199924,
	"./desk-mat.jpg": 94151,
	"./desk-mat@2x.jpg": 155617,
	"./dresses.jpg": 199544,
	"./dresses@2x.jpg": 538056,
	"./face-coverings.jpg": 638835,
	"./face-coverings@2x.jpg": 423765,
	"./headwear.jpg": 442158,
	"./headwear@2x.jpg": 959614,
	"./hemp-fabrics.jpg": 155546,
	"./hemp-fabrics@2x.jpg": 598834,
	"./hoodies.jpg": 939938,
	"./hoodies@2x.jpg": 420954,
	"./kitchen.jpg": 140257,
	"./kitchen@2x.jpg": 856995,
	"./large-basic-cotton-tote.jpg": 973522,
	"./large-basic-cotton-tote@2x.jpg": 663594,
	"./large-basic-tote.jpg": 610178,
	"./large-basic-tote@2x.jpg": 675962,
	"./large-notebooks.jpg": 618117,
	"./large-notebooks@2x.jpg": 404463,
	"./leggings-and-pants.jpg": 211788,
	"./leggings-and-pants@2x.jpg": 305652,
	"./living-room.jpg": 880584,
	"./living-room@2x.jpg": 654328,
	"./long-sleeve-shirts.jpg": 78102,
	"./long-sleeve-shirts@2x.jpg": 627526,
	"./makeup-bags.jpg": 796470,
	"./makeup-bags@2x.jpg": 610022,
	"./market-totes.jpg": 910067,
	"./market-totes@2x.jpg": 539477,
	"./matte-crepe-ruffle-scrunchie.jpg": 995860,
	"./matte-crepe-ruffle-scrunchie@2x.jpg": 436572,
	"./office.jpg": 464089,
	"./office@2x.jpg": 356859,
	"./origami-tote.jpg": 515720,
	"./origami-tote@2x.jpg": 155000,
	"./patches.jpg": 50299,
	"./patches@2x.jpg": 139357,
	"./performance-polyester-fabrics.jpg": 72446,
	"./performance-polyester-fabrics@2x.jpg": 628718,
	"./permanent-sticker.jpg": 515505,
	"./permanent-sticker@2x.jpg": 243219,
	"./pillow-cases.jpg": 210606,
	"./pillow-cases@2x.jpg": 922750,
	"./premium-drawstring-bag.jpg": 70557,
	"./premium-drawstring-bag@2x.jpg": 136199,
	"./purses-and-pouches.jpg": 228975,
	"./purses-and-pouches@2x.jpg": 422057,
	"./robes.jpg": 220064,
	"./robes@2x.jpg": 484688,
	"./scarves.jpg": 572006,
	"./scarves@2x.jpg": 801526,
	"./scoop-bralette.jpg": 10741,
	"./scoop-bralette@2x.jpg": 848831,
	"./seasonal.jpg": 23665,
	"./seasonal@2x.jpg": 877715,
	"./shorts.jpg": 113020,
	"./shorts@2x.jpg": 101252,
	"./silk-charmeuse-ruffle-scrunchie.jpg": 553402,
	"./silk-charmeuse-ruffle-scrunchie@2x.jpg": 870354,
	"./silk-fabrics.jpg": 765571,
	"./silk-fabrics@2x.jpg": 355077,
	"./skirts.jpg": 402217,
	"./skirts@2x.jpg": 195435,
	"./small-notebooks.jpg": 331065,
	"./small-notebooks@2x.jpg": 923931,
	"./spiral-notebooks.jpg": 978535,
	"./spiral-notebooks@2x.jpg": 488577,
	"./stainless-steel-tumbler.jpg": 311517,
	"./stainless-steel-tumbler@2x.jpg": 565191,
	"./stationery-cards.jpg": 123653,
	"./stationery-cards@2x.jpg": 724911,
	"./t-shirts.jpg": 576735,
	"./t-shirts@2x.jpg": 138489,
	"./tank-tops.jpg": 139636,
	"./tank-tops@2x.jpg": 170940,
	"./tea-towels.jpg": 819690,
	"./tea-towels@2x.jpg": 713506,
	"./tote-bags.jpg": 856031,
	"./tote-bags@2x.jpg": 649529,
	"./unisex-joggers.jpg": 446297,
	"./unisex-joggers@2x.jpg": 529211,
	"./urban-tote.jpg": 982930,
	"./urban-tote@2x.jpg": 399082,
	"./vegan-leather-backpack.jpg": 469391,
	"./vegan-leather-backpack@2x.jpg": 991817,
	"./vegan-leather-crossbody-purse.jpg": 390271,
	"./vegan-leather-crossbody-purse@2x.jpg": 162073,
	"./vegan-leather-makeup-bag.jpg": 577929,
	"./vegan-leather-makeup-bag@2x.jpg": 236555,
	"./vegan-leather-tote-bag.jpg": 758806,
	"./vegan-leather-tote-bag@2x.jpg": 840518,
	"./vegan-leathers.jpg": 412635,
	"./vegan-leathers@2x.jpg": 8637,
	"./wall-art.jpg": 946609,
	"./wall-art@2x.jpg": 548051,
	"./woven-polyester-fabrics.jpg": 129157,
	"./woven-polyester-fabrics@2x.jpg": 199983,
	"./yoga-shorts.jpg": 678161,
	"./yoga-shorts@2x.jpg": 243379,
	"./youth-leggings.jpg": 575959,
	"./youth-leggings@2x.jpg": 882321,
	"./zipper-pouches.jpg": 529337,
	"./zipper-pouches@2x.jpg": 496283
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 242153;